import { ReactElement, useState } from "react"
import axiosLib from "axios"

import useErrorHandler from "./hooks/useErrorHandler"
import ErrorHandlerModal from "../components/Modal/ErrorHandlerModal"

const { REACT_APP_API_URL } = process.env

export const axios = axiosLib.create({
  baseURL: REACT_APP_API_URL,
})

type AxiosInterceptorProps = {
  children: ReactElement
}

const AxiosInterceptor = ({ children }: AxiosInterceptorProps) => {
  const [errorModalOpen, setErrorModalOpen] = useState(false)
  const handleErrorModal = () => setErrorModalOpen(!errorModalOpen)

  useErrorHandler(handleErrorModal)

  return (
    <>
      {children}
      <ErrorHandlerModal open={errorModalOpen} toggleMOdal={handleErrorModal} />
    </>
  )
}

export default AxiosInterceptor
